/**
 * Formate un nombre en version abrégée avec des suffixes (K, M, B)
 * @param {number|string} number - Le nombre à formater
 * @param {number} decimals - Nombre de décimales (par défaut 0)
 * @returns {string} - Le nombre formaté (ex: 80000 → "80K")
 */
export function formatNumberWithSuffix(number, decimals = 0) {
    const num = typeof number === "string" ? parseInt(number, 10) : number;

    if (isNaN(num) || num === 0) return "0";

    const suffixes = [
        { value: 1e9, suffix: "B" }, // Milliards
        { value: 1e6, suffix: "M" }, // Millions
        { value: 1e3, suffix: "K" }, // Milliers
    ];

    for (const { value, suffix } of suffixes) {
        if (num >= value) {
            const formatted = (num / value).toFixed(decimals);
            // Supprime les zéros inutiles après la virgule
            return `${parseFloat(formatted)}${suffix}`;
        }
    }

    return num.toString();
}

/**
 * Formate spécifiquement pour les milliers avec "K+"
 * @param {number|string} number - Le nombre à formater
 * @returns {string} - Le nombre formaté avec "K+" (ex: 80000 → "80K+")
 */
export function formatStudentCount(number) {
    const formatted = formatNumberWithSuffix(number);

    // Ajoute un "+" si c'est un nombre avec suffixe
    if (
        formatted.includes("K") ||
        formatted.includes("M") ||
        formatted.includes("B")
    ) {
        return `${formatted}+`;
    }

    return formatted;
}
